import moment from "moment";
import { i18n } from "../../../../language";

function getTodayPathDate() {
    var m = moment();
    var y = m.year();
    var mo = m.month() + 1;
    var d = m.date();
    return y + "-" + (mo < 10 ? "0" : "") + mo + "-" + (d < 10 ? "0" : "") + d;
}

function getCalendarMenuItems() {
    return [
        {
            enabled: true,
            key: "calendar",
            path: "/calendar/d/" + getTodayPathDate(),
            label: i18n.t("message.calendar"),
            icon: {
                type: "material-icons",
                name: "calendar_today",
            },
        },
        {
            enabled: true,
            key: "reservationBuilder",
            path: "/reservation/landing-page",
            label: i18n.t("calendar.reservationBuilder"),
            icon: {
                type: "material-icons",
                name: "web",
            },
        },
        {
            enabled: true,
            key: "events",
            path: "/calendar/events",
            label: i18n.t("calendar.events"),
            icon: {
                type: "material-icons",
                name: "event",
            },
        },
        {
            enabled: true,
            key: "reservations",
            path: "/calendar/reservations",
            label: i18n.t("calendar.reservations"),
            icon: {
                type: "material-icons",
                name: "book_online",
            },
        },
        {
            enabled: true,
            key: "reservationPrograms",
            path: "/reservation/programs",
            label: i18n.t("calendar.reservationPrograms"),
            icon: {
                type: "material-icons",
                name: "event_note",
            },
        },
        {
            enabled: true,
            key: "automations",
            path: "/reservation/automations",
            label: i18n.t("calendar.automations"),
            icon: {
                type: "component",
                name: "AutomationIcon",
                class: "myIcon",
                style: { fill: "var(--color-icon-primary-default)" },
            },
        },
    ];
}

export default getCalendarMenuItems;
